export enum SamlXmlNamespace {
    assertion = 'urn:oasis:names:tc:SAML:2.0:assertion',
    canonicalization = 'http://www.w3.org/2001/10/xml-exc-c14n#',
    encryption = 'http://www.w3.org/2001/04/xmlenc#',
    envelopedSignature = 'http://www.w3.org/2000/09/xmldsig#enveloped-signature',
    protocol = 'urn:oasis:names:tc:SAML:2.0:protocol',
    signature = 'http://www.w3.org/2000/09/xmldsig#',
}
